module.exports = __webpack_public_path__ + "afb6ff5dbd1de25b9a6483c15a0e37a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/nbd_inactive.png
// module id = 283
// module chunks = 3